import { render, staticRenderFns } from "./ConfigurarQuestionario.vue?vue&type=template&id=e672ff88&scoped=true"
import script from "./ConfigurarQuestionario.vue?vue&type=script&lang=js"
export * from "./ConfigurarQuestionario.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarQuestionario.vue?vue&type=style&index=0&id=e672ff88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672ff88",
  null
  
)

export default component.exports